import { makeAutoObservable, reaction } from 'mobx';
import { RootStore } from './rootStore';
import { addMonths, format, isBefore, startOfDay } from 'date-fns';
import { Availability, getAvailability } from '../apiMethods/getAvailability';
import { CookieUtils } from '../utils/cookies';
import { cloneDeep, isEqual } from 'lodash';

export class ColorAvailabilityStore {
  root: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);

    this.root = rootStore;
  }

  init() {
    this.disposers = [
      reaction(
        () => this.availabilityParams,
        params => {
          params && this.loadAvailability(params);
        },
      ),
    ];
  }

  disposers: (() => void)[] = [];

  dispose() {
    this.disposers.forEach(f => f());
  }

  availabilityStart = startOfDay(new Date());

  setAvailabilityStart(_date: Date) {
    const today = startOfDay(new Date());
    let date = startOfDay(_date);

    if (isBefore(date, today)) {
      date = today;
    }

    if (date.valueOf() !== this.availabilityStart.valueOf()) {
      this.availabilityStart = date;
    }
  }

  get availabilityParams() {
    const token = CookieUtils.getToken();
    const user = this.root.authStore.user;
    if (token && !user) {
      return;
    }

    const { rateMode, promocode } = this.root.paramsStore;
    const hotelId = this.root.configStore.hotelId;
    const reservationId = this.root.bookingsStore.bookingInfo?.id;
    const start = this.availabilityStart;
    return { hotelId, start, rateFlow: rateMode, withPromocode: Boolean(promocode), reservationId };
  }

  lastParams: null | {
    hotelId?: number;
    start?: Date;
    withPromocode: boolean;
    rateFlow?: string;
    reservationId?: number;
  } = null;

  loadAvailability = async (params: {
    hotelId?: number;
    start?: Date;
    withPromocode: boolean;
    rateFlow?: string;
    reservationId?: number;
  }) => {
    if (isEqual(params, this.lastParams)) {
      return;
    }

    this.lastParams = cloneDeep(params);

    const { hotelId, start, withPromocode, rateFlow, reservationId } = params;
    if (!hotelId || !start) {
      return;
    }

    const formatDate = (date: Date) => format(date, 'yyyy-MM-dd');

    const arrival = formatDate(start);
    const departure = formatDate(addMonths(start, 3));
    const result = await getAvailability(hotelId, {
      arrival,
      departure,
      rateFlow,
      withPromocode,
      reservationId,
    });

    this.setAvailability(result || []);
  };

  availability: Availability[] = [];

  setAvailability(data: typeof this.availability) {
    this.availability = data;
  }
}
